import { render } from "./Drafts.vue?vue&type=template&id=0f7e37a0&scoped=true"
import script from "./Drafts.vue?vue&type=script&lang=js"
export * from "./Drafts.vue?vue&type=script&lang=js"

import "./Drafts.vue?vue&type=style&index=0&id=0f7e37a0&lang=scss&scoped=true"
import "./Drafts.vue?vue&type=style&index=1&id=0f7e37a0&lang=css"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7e37a0"]])

export default __exports__